import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { useSelector } from 'react-redux';

// Páginas
import HomePage from '../pages/HomePage';
import LoginPage from '../pages/auth/Login';
import ForgotPasswordPage from '../pages/auth/ForgotPassword';
import ResetPasswordPage from '../pages/auth/ResetPassword';
import SelectSede from '../pages/auth/SelectSede';
import NotFoundPage from '../pages/404/NotFoundPage';
import PrivateRoutes from './PrivateRoutes';
import PublicRoute from './PublicRoute';
import PrivateTokenRoutes from './PrivateRoutesToken';

import MiPerfilPage from '../pages/perfil';
import {
  EstudiantesPage,
  EstudiantesPageAgregar,
  EstudiantesPageDetalles,
  EstudiantesPageEditar,
} from '../pages/estudiantes';
import { MatriculaPage } from '../pages/matriculas';
import { ReportesPage } from '../pages/ReportesPage';
import {
  MateriaPage,
  DetalleMateriaPage,
  MisMateriasPage,
  DocenteTitularMateriasPage,
} from '../pages/MateriaPage';
import { SedePage } from '../pages/SedePage';
import {
  GradosPage,
  MisGradosPage,
  MateriasPorGradoPage,
  EstudiantesPorGradoPage,
} from '../pages/grados';
import { ConfiguracionPage } from '../pages/ConfiguracionPage';
import { AccesoPage } from '../pages/AccesoPage';
import { NoTienePermisosPage } from '../pages/NoTienePermisosPage';
import PersonasPage from '../pages/personas';
import PeriodoEscolarPage from '../pages/academico';
import { CalificaciónComportamentalPage, CalificaciónCualititativaPage, RegistrarCalificacionInicialPage, RegistrarCalificacionPage } from '../pages/CalificacionPage';
import { ConsolidadoGeneralPage, ConsolidadoNotasPage, ConsolidadoPorPeriodoPage } from '../pages/ConsolidadoNotasPage';

export default function AppRouter() {
  const { user } = useSelector(state => state.auth);

  return (
    <Routes>
      {/* Rutas públicas */}
      <Route element={<PublicRoute />}>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      </Route>

      {/* Rutas públicas con token */}
      <Route element={<PrivateTokenRoutes />}>
        <Route path="/reset-password/:email/:token" element={<ResetPasswordPage />} />
      </Route>

      {/* Rutas privadas generales - Acceso para todos los roles autenticados */}
      <Route
        element={
          <PrivateRoutes
            allowedRoles={['ADMIN_ROLE', 'DOCENTE_TITULAR_ROLE', 'DOCENTE_ROLE', 'COORDINADOR_ROLE']}
            userRole={user?.usuario?.rol}
          />
        }
      >
        <Route path="/" element={<HomePage />} />
        <Route path="/perfil" element={<MiPerfilPage />} />
        <Route path="/select-sede" element={<SelectSede />} />
        <Route path="/no-tiene-permisos" element={<NoTienePermisosPage />} />
      </Route>

      {/* Rutas para gestión de estudiantes y matrículas */}
      <Route
        element={
          <PrivateRoutes
            allowedRoles={['ADMIN_ROLE', 'COORDINADOR_ROLE', 'DOCENTE_TITULAR_ROLE']}
            userRole={user?.usuario?.rol}
          />
        }
      >
        <Route path="/:idSede/estudiantes" element={<EstudiantesPage />} />
        <Route path="/:idSede/estudiantes/nuevo" element={<EstudiantesPageAgregar />} />
        <Route path="/:idSede/estudiantes/:id" element={<EstudiantesPageDetalles />} />
        <Route path="/:idSede/estudiantes/editar/:id" element={<EstudiantesPageEditar />} />
        <Route path="/:idSede/matriculas" element={<MatriculaPage />} />
      </Route>

      {/* Rutas para docentes (incluye titulares) */}
      <Route
        element={
          <PrivateRoutes
            allowedRoles={['ADMIN_ROLE', 'COORDINADOR_ROLE', 'DOCENTE_ROLE', 'DOCENTE_TITULAR_ROLE']}
            userRole={user?.usuario?.rol}
          />
        }
      >
        <Route path="/mis-asignaturas" element={<MisMateriasPage />} />
        <Route path="/asignaturas/:id" element={<DetalleMateriaPage />} />
        <Route path="/asignaturas/:id/calificaciones" element={<RegistrarCalificacionPage />} />
        <Route path="/asignaturas/:id/calificaciones-inicial" element={<RegistrarCalificacionInicialPage />} />
        <Route path="/asignaturas/:id/calificaciones-cualitativa" element={<CalificaciónCualititativaPage />} />
        <Route path="/asignaturas/:id/calificaciones-comportamental" element={<CalificaciónComportamentalPage />} />
      </Route>

      {/* Rutas para gestión académica (Admin y Coordinador) */}
      <Route
        element={
          <PrivateRoutes
            allowedRoles={['ADMIN_ROLE', 'COORDINADOR_ROLE']}
            userRole={user?.usuario?.rol}
          />
        }
      >
        <Route path="/:idSede/consolidado-notas" element={<ConsolidadoNotasPage />} />
        <Route path="/:idSede/consolidado-notas/periodo" element={<ConsolidadoPorPeriodoPage />} />
        <Route path="/:idSede/consolidado-notas/general" element={<ConsolidadoGeneralPage />} />
        <Route path="/:idSede/asignaturas" element={<MateriaPage />} />
        <Route path="/:idSede/grados" element={<GradosPage />} />
        <Route path="/:idSede/grados/:id" element={<EstudiantesPorGradoPage />} />
        <Route path="/:idSede/grados/:id/agregar" element={<EstudiantesPageAgregar />} />
        <Route path="/periodo-escolar" element={<PeriodoEscolarPage />} />
        <Route path="/sedes" element={<SedePage />} />
        <Route path="/:idSede/reportes" element={<ReportesPage />} />
      </Route>

      {/* Rutas para docentes titulares y coordinadores */}
      <Route
        element={
          <PrivateRoutes
            allowedRoles={['ADMIN_ROLE', 'COORDINADOR_ROLE', 'DOCENTE_TITULAR_ROLE']}
            userRole={user?.usuario?.rol}
          />
        }
      >
        <Route path="/mis-grados" element={<MisGradosPage />} />
        <Route path="/grados/:id/estudiantes" element={<EstudiantesPorGradoPage />} />
        <Route path="/grados/:id/asignaturas" element={<MateriasPorGradoPage />} />
        <Route path="/grados/:id/asignaturas/lista" element={<DocenteTitularMateriasPage />} />
      </Route>

      {/* Rutas exclusivas para administrador */}
      <Route
        element={
          <PrivateRoutes
            allowedRoles={['ADMIN_ROLE']}
            userRole={user?.usuario?.rol}
          />
        }
      >
        <Route path="/usuarios" element={<PersonasPage />} />
        <Route path="/configuraciones" element={<ConfiguracionPage />} />
        <Route path="/accesos" element={<AccesoPage />} />
      </Route>

      {/* Ruta catch all */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
